import React, { useState } from 'react';
import { useLocation } from 'react-router-dom';
import qs from 'query-string';
import classNames from 'classnames/bind';
import InputText from 'app/components/common/InputText';
import styles from './Pagination.module.scss';

const cx = classNames.bind(styles);

const Pagination = ({ onChange = null, totalCount = 0, current = 0, displayItem = 10, displayPage = 10, keepQuery = false, style = undefined, showQuickJumper = false }) => {
	const [inputPage, setInputPage] = useState('');
	const pageCount = Math.ceil(totalCount / displayItem) || 1;
	const displayStartPage = Math.floor((current - 1) / displayPage) * displayPage + 1;
	const displayEndPage = displayStartPage + displayPage - 1;
	const prevPage = displayStartPage > 1 ? displayStartPage - displayPage : 1;
	const nextPage = displayEndPage < pageCount ? displayEndPage + 1 : pageCount;
	const numbers = [];
	const prevButton = displayStartPage > 1;
	const nextButton = pageCount > displayEndPage;

	const { pathname, search } = useLocation();
	const queryParameter = (number) => {
		const parsed = qs.parse(search);
		const result = keepQuery
			? {
					...parsed,
					page: number,
				}
			: {
					page: number,
				};
		return qs.stringify(result);
	};

	const handleOnChange = (e, num) => {
		e.preventDefault();
		onChange(queryParameter(num));
	};

	for (let i = displayStartPage; i <= displayEndPage && i <= pageCount; i += 1) {
		numbers.push(i);
	}

	const pagenation = numbers.map((item, i) => {
		const key = `key${i}`;
		return (
			<a
				key={key}
				href={`${pathname}?${queryParameter(item)}`}
				onClick={(e) => handleOnChange(e, item)}
				className={cx('link', { active: item === current })}
			>
				{item}
			</a>
		);
	});

	const onSubmitPage = (e) => {
		e.preventDefault();
		if (!inputPage) {
			return;
		}
		if (Number(inputPage) < 1) {
			alert('1페이지 이상 입력가능합니다.');
			return;
		}
		if (Number(inputPage) > pageCount) {
			alert(`최대 ${pageCount}페이지 까지 입력가능합니다.`);
			return;
		}
		handleOnChange(e, Number(inputPage));
		setInputPage('');
	};

	return (
		<>
			<div
				className={cx('pages')}
				style={style}
			>
				<a
					href={`${pathname}/${queryParameter(prevPage)}`}
					onClick={(e) => (prevButton ? handleOnChange(e, prevPage) : e.preventDefault())}
					className={cx('arrow', 'prev', { active: prevButton })}
				>
					이전 {displayPage}페이지
				</a>
				{pagenation}
				<a
					href={`${pathname}/${queryParameter(nextPage)}`}
					onClick={(e) => (nextButton ? handleOnChange(e, nextPage) : e.preventDefault())}
					className={cx('arrow', 'next', { active: nextButton })}
				>
					다음 {displayPage}페이지
				</a>
			</div>
			{showQuickJumper && (
				<form
					className={cx('jumper')}
					onSubmit={onSubmitPage}
				>
					<InputText
						type="customNumber"
						inputMode="numeric"
						name="input_page"
						id="input_page"
						inputDesign="square"
						classArray={[cx('input_page')]}
						inputDesignClass="h30"
						value={inputPage}
						onChange={(e) => setInputPage(e.target.value)}
					/>
					<button className={cx('btn_jumper')}>페이지로 바로이동</button>
				</form>
			)}
		</>
	);
};

export default Pagination;
